import { css } from '@emotion/react';

const headerStyles = css`
    .title-header {
        Title {
            margin: 0;
        }
        p {
            margin: 0;
        }
    }

    .main-header,
    .sub-header {
        margin: 0;
    }
`;

export const themeStyles = css`
    .title-header {
        Title {
            margin: 0;
        }
        p {
            margin: 0;
        }
    }

    .main-header,
    .sub-header {
        margin: 0;
    }

    h1 {
        font-size: var(--heading-level-one-fontSize);
        font-weight: var(--heading-level-one-fontWeight);
        font-family: var(--heading-level-one-fontFamily);
        letter-spacing: var(--heading-level-one-letterSpacing);
        word-spacing: var(--heading-level-one-wordSpacing);
        line-height: var(--heading-level-one-lineHeight);
        color: var(--default-text-color);
    }

    h2 {
        font-size: var(--heading-level-two-fontSize);
        font-weight: var(--heading-level-two-fontWeight);
        font-family: var(--heading-level-two-fontFamily);
        letter-spacing: var(--heading-level-two-letterSpacing);
        word-spacing: var(--heading-level-two-wordSpacing);
        line-height: var(--heading-level-two-lineHeight);
        color: var(--default-text-color);
    }

    h3 {
        font-size: var(--heading-level-three-fontSize);
        font-weight: var(--heading-level-three-fontWeight);
        font-family: var(--heading-level-three-fontFamily);
        letter-spacing: var(--heading-level-three-letterSpacing);
        word-spacing: var(--heading-level-three-wordSpacing);
        line-height: var(--heading-level-three-lineHeight);
        color: var(--default-text-color);
    }

    h4 {
        font-size: var(--heading-level-four-fontSize);
        font-weight: var(--heading-level-four-fontWeight);
        font-family: var(--heading-level-four-fontFamily);
        letter-spacing: var(--heading-level-four-letterSpacing);
        word-spacing: var(--heading-level-four-wordSpacing);
        line-height: var(--heading-level-four-lineHeight);
        color: var(--default-text-color);
    }

    h5 {
        font-size: var(--heading-level-five-fontSize);
        font-weight: var(--heading-level-five-fontWeight);
        font-family: var(--heading-level-five-fontFamily);
        letter-spacing: var(--heading-level-five-letterSpacing);
        word-spacing: var(--heading-level-five-wordSpacing);
        line-height: var(--heading-level-five-lineHeight);
        color: var(--default-text-color);
    }

    h6 {
        font-size: var(--heading-level-six-fontSize);
        font-weight: var(--heading-level-six-fontWeight);
        font-family: var(--heading-level-six-fontFamily);
        letter-spacing: var(--heading-level-six-letterSpacing);
        word-spacing: var(--heading-level-six-wordSpacing);
        line-height: var(--heading-level-six-lineHeight);
        color: var(--default-text-color);
    }
`;

export default headerStyles;
